import LocalizedStrings from "react-localization";
import { VnLocalizedStrings } from "./vietnam";

export const strings = new LocalizedStrings({
  vietnam: VnLocalizedStrings,
});
